const mapIcons = {
    equipmentIcons: [
        "barricade_black",
        "barricade_blue",
        "barricade_orange",
        "barricade_pink",
        "barricade_purple",
        "barricade_red",
        "barricade_turquoise",
        "barricade_yellow",
        "concrete_pump_black",
        "concrete_pump_blue",
        "concrete_pump_orange",
        "concrete_pump_pink",
        "concrete_pump_purple",
        "concrete_pump_red",
        "concrete_pump_turquoise",
        "concrete_pump_yellow",
        "crane_truck_black",
        "crane_truck_blue",
        "crane_truck_orange",
        "crane_truck_pink",
        "crane_truck_purple",
        "crane_truck_red",
        "crane_truck_turquoise",
        "crane_truck_yellow",
        "crawler_crane_black",
        "crawler_crane_blue",
        "crawler_crane_orange",
        "crawler_crane_pink",
        "crawler_crane_purple",
        "crawler_crane_red",
        "crawler_crane_turquoise",
        "crawler_crane_yellow",
        "fork_lift_black",
        "fork_lift_blue",
        "fork_lift_orange",
        "fork_lift_pink",
        "fork_lift_purple",
        "fork_lift_red",
        "fork_lift_turquoise",
        "fork_lift_yellow",
        "hook_black",
        "hook_blue",
        "hook_orange",
        "hook_pink",
        "hook_purple",
        "hook_red",
        "hook_turquoise",
        "hook_yellow",
        "office_trailer_black",
        "office_trailer_blue",
        "office_trailer_orange",
        "office_trailer_pink",
        "office_trailer_purple",
        "office_trailer_red",
        "office_trailer_turquoise",
        "office_trailer_yellow",
        "restroom_black",
        "restroom_blue",
        "restroom_orange",
        "restroom_pink",
        "restroom_purple",
        "restroom_red",
        "restroom_turquoise",
        "restroom_yellow",
        "skip_hoist_black",
        "skip_hoist_blue",
        "skip_hoist_orange",
        "skip_hoist_pink",
        "skip_hoist_purple",
        "skip_hoist_red",
        "skip_hoist_turquoise",
        "skip_hoist_yellow",
        "tower_crane_black",
        "tower_crane_blue",
        "tower_crane_orange",
        "tower_crane_pink",
        "tower_crane_purple",
        "tower_crane_red",
        "tower_crane_turquoise",
        "tower_crane_yellow",
    ],
    // standardIcons: [
    //     "barrier_std_icon",
    //     "exit_std_icon",
    //     "gate_std_icon",
    //     "jobsite_trailer_std_icon",
    //     "no-entry_std_icon",
    //     "portable_toilet_std_icon",
    // ],
    sdfIcons: [
        "arrow_sdf_icon",
        "barbed_wire_sdf_icon",
        "bullet_sdf_icon",
        "crane_sdf_icon",
        "delivery_truck_sdf_icon",
        "dumpster_sdf_icon",
        "first_aid_sdf_icon",
        "left-chevron_sdf_icon",
        "left-double-chevron_sdf_icon",
        "lightning_sdf_icon",
        "map_marker_sdf_icon",
        "no-entry_sdf_icon",
        "no-parking_sdf_icon",
        "parking-sign_sdf_icon",
        "portable-toilet_sdf_icon",
        "right-chevron_sdf_icon",
        "right-double-chevron_sdf_icon",
        "road-barrier_sdf_icon",
        "two_way_sdf_icon_1",
        "two_way_sdf_icon_2",
        "warning_sdf_icon",
    ],
    // Some items commented out as not currently being used. Callen only wants 8 letters/numbers.
    // Can be added back in later if needed.
    letterIcons: [
        "square-a-solid-full",
        "square-b-solid-full",
        "square-c-solid-full",
        "square-d-solid-full",
        "square-e-solid-full",
        "square-f-solid-full",
        "square-g-solid-full",
        "square-h-solid-full",
        // "square-i-solid-full",
        // "square-j-solid-full",
        // "square-k-solid-full",
        // "square-l-solid-full",
        // "square-m-solid-full",
        // "square-n-solid-full",
        // "square-o-solid-full",
        // "square-p-solid-full",
        // "square-q-solid-full",
        // "square-r-solid-full",
        // "square-s-solid-full",
        // "square-t-solid-full",
        // "square-u-solid-full",
        // "square-v-solid-full",
        // "square-w-solid-full",
        // "square-x-solid-full",
        // "square-y-solid-full",
        // "square-z-solid-full",
        "square-a-green-full",
        "square-b-green-full",
        "square-c-green-full",
        "square-d-green-full",
        "square-e-green-full",
        "square-f-green-full",
        "square-g-green-full",
        "square-h-green-full",
        // "square-i-green-full",
        // "square-j-green-full",
    ],
    numberIcons: [
        "square-0-solid-full",
        "square-1-solid-full",
        "square-2-solid-full",
        "square-3-solid-full",
        "square-4-solid-full",
        "square-5-solid-full",
        "square-6-solid-full",
        "square-7-solid-full",
        // "square-8-solid-full",
        // "square-9-solid-full",
        "square-0-green-full",
        "square-1-green-full",
        "square-2-green-full",
        "square-3-green-full",
        "square-4-green-full",
        "square-5-green-full",
        "square-6-green-full",
        "square-7-green-full",
        // "square-8-green-full",
        // "square-9-green-full",
    ],
};

export default mapIcons;
